import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { CookieConsentService } from 'src/app/tools/cookie-consent.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent implements OnInit, OnDestroy {
  private cookieConsentService = inject(CookieConsentService);
  private cdr = inject(ChangeDetectorRef);
  private sub: Subscription;

  visible = false;
  detailedView = false;
  analyticsChecked = false;
  functionalChecked = false;

  ngOnInit(): void {
    if (!this.cookieConsentService.getConsent()) {
      this.visible = true;
    }
    this.sub = this.cookieConsentService.showBanner$.subscribe(() => {
      const consent = this.cookieConsentService.getConsent();
      if (consent) {
        this.analyticsChecked = consent.analytics;
        this.functionalChecked = consent.functional;
      }
      this.detailedView = false;
      this.visible = true;
      this.cdr.markForCheck(); // OnPush : réaffichage déclenché par un observable
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  acceptAll(): void {
    this.cookieConsentService.setConsent({ analytics: true, functional: true });
    this.visible = false;
  }

  refuseAll(): void {
    this.cookieConsentService.setConsent({ analytics: false, functional: false });
    this.visible = false;
  }

  showDetails(): void {
    this.detailedView = true;
  }

  saveChoices(): void {
    this.cookieConsentService.setConsent({
      analytics: this.analyticsChecked,
      functional: this.functionalChecked,
    });
    this.visible = false;
  }
}
